import(/* webpackMode: "eager", webpackExports: ["FallbackImage"] */ "/vercel/path0/app/components/FallbackImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocalRecommendations"] */ "/vercel/path0/app/components/LocalRecommendations.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SavedEntityActions"] */ "/vercel/path0/app/components/SavedEntityActions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteHeader"] */ "/vercel/path0/app/components/SiteHeader.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@16.2.6_react-dom@19.2.7_react@19.2.7__react@19.2.7/node_modules/next/dist/client/image-component.js");
